export default __webpack_public_path__ + "static/media/ulucinar5.86934676.jpg";